var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessTravelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.277C0.55469 47.1642 41.2395 47.6822 39.4641 20.8673C41.4983 -5.24501 4.0315 -6.98329 0 19.277ZM30.1309 23.5406H30.1348C27.6472 24.0934 26.1365 23.7701 24.1545 23.8565C22.4163 23.4317 23.8791 26.5274 18.7759 30.7462C15.2949 32.983 17.4587 27.2892 18.9177 24.1881C19.5017 23.7564 14.999 24.0621 13.3296 24.0426C9.41333 23.8795 10.5186 25.565 9.51489 19.2525C8.80615 13.94 8.75244 10.6632 10.219 12.4874C14.7295 19.0143 9.03979 17.4127 21.6724 17.2018C22.625 17.7496 23.3547 12.6891 24.8562 12.9571C25.6663 13.6388 25.2598 16.9864 25.3882 16.982C25.509 17.1837 26.1565 16.9923 28.3645 16.9532C33.2732 16.9166 34.7231 21.9894 30.1309 23.5406Z",
    fill: "#193666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessTravelIcon);
export default __webpack_public_path__ + "static/media/business-travel-icon.5dcd01698a4e7ce57ee9eee0b39ad33b.svg";
export { ForwardRef as ReactComponent };